module.exports = __webpack_public_path__ + "img/center_mode.16d9c228.svg";